import script from "./VideoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoModal.vue?vue&type=script&setup=true&lang=js"

import "./VideoModal.vue?vue&type=style&index=0&id=7543f4d8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7543f4d8"]])

export default __exports__